import { useRecoilValue } from 'recoil';
import { navStateAtom } from '../../../models/atoms/ui_atoms';
import { NavButton } from './NavButton';
import { DesktopLanguageSelector } from './DesktopLanguageSelector';
import { Box } from '@mui/material';
import { NavMenuOption } from './Navbar';

type Props = { navMenuOptions: Array<NavMenuOption | null> };

export function DesktopNavMenu({ navMenuOptions }: Props) {
  const navState = useRecoilValue(navStateAtom);

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'none', md: 'flex' },
        justifyContent: 'flex-end',
        gap: '10px',
      }}
    >
      {navMenuOptions.map(option =>
        option ? (
          <NavButton
            key={option.state}
            isActive={navState === option.state}
            onClick={option.onClick}
          >
            {option.label}
          </NavButton>
        ) : null,
      )}
      <DesktopLanguageSelector />
    </Box>
  );
}
